import { ATBeaconLoadingSpinner } from 'components/common/beacon/beaconRegistration';
import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useLazyGetTransferConfirmationQuery } from 'src/api/atv/atvApi';
import { PageRoutes } from 'src/common/constants';
import { DocusignEventType } from 'src/utils/constants';
import DocusignConfirmation from './handlers/DocusignConfirmation';
import DocusignSignAndReturn from './handlers/DocusignSignAndReturn';
import ErrorContent from './handlers/ErrorContent';
import PershingConfirmationStatus from './handlers/PershingConfirmationStatus';

const DocusignReturn: React.FC = () => {
  const [searchParams] = useSearchParams();
  const confirmationNumber = searchParams.get('confirmationNumber');
  const event = searchParams.get('event');
  const [getTransferConfirmation, { data, isLoading, error }] =
    useLazyGetTransferConfirmationQuery();

  const [pershingStatusDone, setPershingStatusDone] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    if (error) {
      navigate(PageRoutes.ERROR);
    }
  }, [error, navigate]);

  useEffect(() => {
    if (pershingStatusDone && confirmationNumber) {
      getTransferConfirmation({ confirmationNumber });
    }
  }, [pershingStatusDone, confirmationNumber, getTransferConfirmation]);

  if (!pershingStatusDone && confirmationNumber) {
    return (
      <PershingConfirmationStatus
        confirmationNumber={confirmationNumber}
        onSuccess={() => setPershingStatusDone(true)}
      />
    );
  }

  if (isLoading) {
    return (
      <div className="content-loading">
        <ATBeaconLoadingSpinner scale={'normal'} />
      </div>
    );
  }
  if (
    error ||
    !confirmationNumber ||
    event !== DocusignEventType.SIGNING_COMPLETE ||
    !data
  ) {
    return <ErrorContent />;
  }
  const isMailInFormRequired = data.isMailInFormRequired;

  return isMailInFormRequired ? (
    <DocusignSignAndReturn
      confirmationNumber={confirmationNumber}
      accountType={data.accountType}
      institutionName={data.institutionName}
    />
  ) : (
    <DocusignConfirmation
      confirmationNumber={confirmationNumber}
      processType={data.processType}
    />
  );
};

export default DocusignReturn;
